import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getRoomInfo = async (roomId: string): Promise<AxiosResponse> =>
  AxiosInstance.get('rooms.info', {
    params: {
      roomId,
    },
  });
